import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import swal from 'sweetalert2'; 


@Component({
  selector: 'app-cursos',
  templateUrl: './cursos.component.html',
  styleUrls: ['./cursos.component.scss']
})
export class CursosComponent implements OnInit {

  loading: boolean = false;
  bregistro = false;
  usu;
  lst;
  org_
  itm = {
    id:0,
    clave:"",
    nombre:"",    
    descripcion:"",    
  }

  cat;selcat;
  scl;selscl;
  vig;selvig;
  hrs;selhrs;

  id_cliente;

  constructor(
    public authService: AuthService,
    public router: Router,    
  ) {     
  }

  ngOnInit(): void {
    //this.usu = this.authService.leerUsuario()    
    this.usu = 0
    if (this.usu != null){
      
      this.id_cliente=Number(localStorage.getItem("id_cliente"));

      var _scl = [];
      _scl.push({ id: 1, nombre: "1 - 10" });
      _scl.push({ id: 2, nombre: "Aprobado - No aprobado" });
      this.scl = _scl;

      var _vig = [];
      _vig.push({ id: 1, nombre: "1" });
      _vig.push({ id: 2, nombre: "2" });
      _vig.push({ id: 3, nombre: "3" });
      _vig.push({ id: 4, nombre: "4" });
      this.vig = _vig;

      var _hrs = [];
      _hrs.push({ id: 1, nombre: "1" });
      _hrs.push({ id: 2, nombre: "2" });
      _hrs.push({ id: 3, nombre: "3" });
      _hrs.push({ id: 4, nombre: "4" });
      _hrs.push({ id: 5, nombre: "5" });
      _hrs.push({ id: 6, nombre: "6" });
      _hrs.push({ id: 7, nombre: "7" });
      _hrs.push({ id: 8, nombre: "8" });
      _hrs.push({ id: 9, nombre: "9" });
      _hrs.push({ id: 10, nombre: "10" });
      this.hrs = _hrs;

      this.ls_listado();
      this.ls_categorias();
    }
    else{
      this.router.navigate(['/login']);
    }
  }

  
  ls_categorias(){
    var sqry = "";
    sqry = " select" +
           " id, nombre" +
           " from tblcategoria_ent " +
           " where estado <> 'C'" +
           " order by nombre";
    this.loading =  true;
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;   
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        var _cat = []             
        if (res.length!=0){
          for (let i = 0; i < res.length; i++){
            _cat.push({ 
              id: res[i].id,
              nombre: res[i].nombre,
            });
          }
          this.cat = _cat;
        }        
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    }); 
  }

  ls_listado(){
    this.lst = null;
    var sqry;
    sqry = " select" +
          " tblcurso.id, tblcurso.clave,tblcurso.nombre, tblcurso.descripcion," +
          " tblcurso.escala, tblcurso.vigencia, tblcurso.horas," + 
          " tblcategoria_ent.nombre as categoria,tblcurso.idcategoria " +
          " from tblcurso,tblcategoria_ent" +
          " where tblcurso.estado <> 'C'" +
          " and tblcurso.idcategoria = tblcategoria_ent.id" +
          " order by tblcurso.nombre";
    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0){
            var _lst = []      
            for (let i = 0; i < res.length; i++){

              var objIndex = this.scl.findIndex(((itm1 :any) => itm1.id == res[i].escala));  
              var escala = this.scl[objIndex].nombre;
              objIndex = this.vig.findIndex(((itm1 :any) => itm1.id == res[i].vigencia));  
              var vigencia = this.vig[objIndex].nombre;
              _lst.push({ 
                id: res[i].id,
                clave: res[i].clave,
                nombre: res[i].nombre,
                descripcion: res[i].descripcion,
                idescala: res[i].escala,
                escala: escala,
                idvigencia: res[i].vigencia,
                vigencia: vigencia,
                idhoras: res[i].horas,
                idcategoria: res[i].idcategoria,
                categoria: res[i].categoria,
              });
            }
            this.lst = _lst;   
          }
          else{            
            //swal.fire('No existe información!', '', 'info');            
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });  
  }

  registro(itm,id){
    this.bregistro = true;
    if (id == 0){
      this.itm.id = 0;
      this.itm.clave = "";
      this.itm.nombre = "";
      this.itm.descripcion = "";

      this.selscl = {id: 0, nombre:""}
      this.selvig = {id: 0, nombre:""}
      this.selhrs = {id: 0, nombre:""}
      this.selcat = {id: 0, nombre:""}
    }else{
      this.itm.id = itm.id;
      this.itm.clave = itm.clave;
      this.itm.nombre = itm.nombre;
      this.itm.descripcion = itm.descripcion;

      this.selscl = {id: itm.idescala, nombre: itm.escala }
      this.selvig = {id: itm.idvigencia, nombre: itm.vigencia }
      this.selhrs = {id: itm.idhoras, nombre: itm.idhoras.toString() }
      this.selcat = {id: itm.idcategoria, nombre: itm.categoria }
    }

  }

  cancelar(){
    this.bregistro = false;
  }
  
  guardar(){
    if (this.itm.clave == ""){
      swal.fire('', '<h5>Proporcione la clave</h5>', 'warning');
      return;
    }
    if (this.itm.nombre == ""){
      swal.fire('', '<h5>Proporcione el nombre</h5>', 'warning');
      return;
    }
    if (this.selcat.id == 0){
      swal.fire('', '<h5>Proporcione la categoría</h5>', 'warning');
      return;
    }
    if (this.selscl.id == 0){
      swal.fire('', '<h5>Proporcione la escala</h5>', 'warning');
      return;
    }
    if (this.selvig.id == 0){
      swal.fire('', '<h5>Proporcione la vigencia</h5>', 'warning');
      return;
    }
    if (this.selhrs.id == 0){
      swal.fire('', '<h5>Proporcione las horas</h5>', 'warning');
      return;
    }

    var sqry;
    if (this.itm.id == 0){
      sqry = " insert into tblcurso (" +
             " idcategoria,clave,nombre,descripcion,escala,vigencia,horas,estado)" +
             " values (" +
             this.selcat.id + ",'" +
             this.itm.clave + "','" +
             this.itm.nombre + "','" +             
             this.itm.descripcion + "'," +             
             this.selscl.id  + "," +
             this.selvig.id  + "," +
             this.selhrs.id  + ",'" +
             "A" + "')";
    }else{
      sqry = " update tblcurso set" +
             " clave = '" + this.itm.clave + "'," +
             " nombre = '" + this.itm.nombre + "'," +             
             " descripcion = '" + this.itm.descripcion + "'," +             
             " idcategoria = " + this.selcat.id + "," +             
             " escala = " + this.selscl.id + "," +             
             " vigencia = " + this.selvig.id + "," +             
             " horas = '" + this.selhrs.id + "'" +             
             " where id = " + this.itm.id;
    }
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;   
        this.bregistro = false;
        this.ls_listado();
        if (this.itm.id == 0)
          swal.fire({ icon: "success", title: "Información registrada", showConfirmButton: false, timer: 1000 });
        else
          swal.fire({ icon: "success", title: "Información modificada", showConfirmButton: false, timer: 1000 });
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }

  elimiar(id){
    if (confirm("¿Desea eliminar el registro?")) {
      var sqry;
      sqry = " update tblcurso set estado = 'C' where id = " + id;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;   
          this.bregistro = false;
          this.ls_listado();
          swal.fire({ icon: "success", title: "Registro eliminado", showConfirmButton: false, timer: 1000 });
      },
      error => {
          this.loading =  false;
          swal.fire('Datos incorrectos', '', 'error');
      });
    }
    
  }


  binstructor: boolean = false;
  per;selper;
  instructor(itm){
    this.binstructor = true;
    this.itm.id = itm.id;
    this.itm.clave = itm.clave;
    this.itm.nombre = itm.nombre;

    var sqry = "";
    sqry = " select" +
           " id, nombre, apaterno, amaterno" +
           " from tblpersona_tl" +
           " where edoper <> 'C'" +
           " and id not in (" +
                            " select idpersona from tblcursoinstructor" +
                            " where idcurso = " + itm.id +
                            ")" +
           " and id_cliente = " + this.id_cliente +
           " order by nombre, apaterno, amaterno";

    this.loading =  true;
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;   
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        var _per = []             
        if (res.length!=0){
          for (let i = 0; i < res.length; i++){
            _per.push({ 
              id: res[i].id,
              nombre: res[i].nombre + ' ' + res[i].apaterno + ' ' + res[i].amaterno,
            });
          }
          this.per = _per;
          this.selper = null;
          this.lista_instructores();
        }        
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    }); 
  }


  agregar(){
    if (this.selper == null){
      swal.fire('', '<h3>Seleccione al instructor</h3>', 'warning');
      return;
    }
    var sqry;
    sqry = " insert into tblcursoinstructor (idcurso,idpersona) values (" +
            this.itm.id + "," +
            this.selper.id + ")";
           
    this.loading =  true;
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;                
        swal.fire({ icon: "success", title: "Registro generado", showConfirmButton: false, timer: 1000 });
        this.instructor(this.itm);
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    }); 
  }


  lst1;
  lista_instructores(){
    var sqry = "";
    sqry = " select" +
           " tblcursoinstructor.id, nombre, apaterno, amaterno" +           
           " from tblpersona_tl,tblcursoinstructor" +
           " where tblpersona_tl.id = tblcursoinstructor.idpersona" +
           " and tblcursoinstructor.idcurso = " + this.itm.id +
           " and edoper <> 'C'" +           
           " and id_cliente = " + this.id_cliente +
           " order by nombre, apaterno, amaterno";
    this.loading =  true;
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;   
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        var _lst = []             
        if (res.length!=0){
          for (let i = 0; i < res.length; i++){
            _lst.push({ 
              id: res[i].id,
              nombre: res[i].nombre + ' ' + res[i].apaterno + ' ' + res[i].amaterno,
            });
          }
          this.lst1 = _lst;          
        }        
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    }); 
  }

  regresar(){
    this.binstructor = false;
  }


  elimiarInstructor(id){
    if (confirm("¿Desea eliminar el registro?")) {
      var sqry;
      sqry = " delete from tblcursoinstructor where id = " + id;
      this.loading =  true;             
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;             
          this.instructor(this.itm);
          swal.fire({ icon: "success", title: "Registro eliminado", showConfirmButton: false, timer: 1000 });
      },
      error => {
          this.loading =  false;
          swal.fire('Datos incorrectos', '', 'error');
      });
    }
    
  }


}

